import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { DialogHelper } from './dialogHelper';

@Injectable()
export class ExceptionHelper {
  constructor(
    private dialog: DialogHelper
  ) {}

  public showError(err: HttpErrorResponse, dangerModalId: string) {
    if (err.error != null && err.error.code != null) {
      this.dialog.writeToModal(err.error.message);
      this.dialog.showModal(dangerModalId);
    } else {
      this.dialog.writeToModal('You have encountered unexpected error. Please contact our support.');
      this.dialog.showModal(dangerModalId);
    }
  }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/helper/exceptionHelper.ts